import React, { useState, useEffect } from 'react';

import MainNavigation from '../../components/ui/MainNavigation';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import KPICard from './components/KPICard';
import RecentRFQList from './components/RecentRFQList';
import RevenueChart from './components/RevenueChart';
import NotificationPanel from './components/NotificationPanel';
import QuickActionPanel from './components/QuickActionPanel';
import CustomerEngagementChart from './components/CustomerEngagementChart';

const AdminDashboard = () => {
  const [currentUser] = useState({
    id: 1,
    name: "Sarah Johnson",
    email: "sarah.johnson@techtribes.ug",
    role: "admin"
  });

  const [dashboardData, setDashboardData] = useState({
    kpis: [],
    recentRFQs: [],
    revenueData: [],
    notifications: [],
    customerEngagement: []
  });

  const [dateRange, setDateRange] = useState('30d');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Mock data - in real app, this would come from API
    const mockData = {
      kpis: [
        {
          title: "Total RFQs",
          value: "247",
          change: "+12.5%",
          changeType: "positive",
          icon: "FileText",
          trend: [45, 52, 48, 61, 55, 67, 69, 72]
        },
        {
          title: "Conversion Rate",
          value: "68.3%",
          change: "+5.2%",
          changeType: "positive",
          icon: "TrendingUp",
          trend: [62, 65, 63, 68, 66, 70, 68, 68]
        },
        {
          title: "Monthly Revenue",
          value: "UGX 45.2M",
          change: "+18.7%",
          changeType: "positive",
          icon: "DollarSign",
          trend: [38, 42, 39, 45, 43, 47, 45, 45]
        },
        {
          title: "Active Customers",
          value: "1,234",
          change: "+8.9%",
          changeType: "positive",
          icon: "Users",
          trend: [1100, 1150, 1120, 1200, 1180, 1230, 1220, 1234]
        },
        {
          title: "Pending Quotes",
          value: "23",
          change: "-15.3%",
          changeType: "positive",
          icon: "Clock",
          trend: [35, 32, 28, 25, 27, 24, 26, 23]
        },
        {
          title: "System Uptime",
          value: "99.8%",
          change: "+0.1%",
          changeType: "positive",
          icon: "Activity",
          trend: [99.5, 99.7, 99.6, 99.8, 99.7, 99.9, 99.8, 99.8]
        }
      ],
      recentRFQs: [
        {
          id: "RFQ-2024-001",
          title: "Network Infrastructure Upgrade for Government Ministry",
          customerName: "John Mukasa",
          company: "Ministry of ICT",
          category: "Infrastructure",
          status: "pending",
          priority: "high",
          budget: "UGX 50M - 100M",
          submittedAt: new Date(Date.now() - 2 * 60 * 60 * 1000),
          deadline: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
        },
        {
          id: "RFQ-2024-002",
          title: "Custom Software Development for Banking Solution",
          customerName: "Mary Nakato",
          company: "Uganda Commercial Bank",
          category: "Software",
          status: "in_progress",
          priority: "high",
          budget: "UGX 200M+",
          submittedAt: new Date(Date.now() - 4 * 60 * 60 * 1000),
          deadline: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)
        },
        {
          id: "RFQ-2024-003",
          title: "IT Consultancy for Digital Transformation Strategy",
          customerName: "David Ssemakula",
          company: "Kampala City Council",
          category: "Consultancy",
          status: "quoted",
          priority: "medium",
          budget: "UGX 25M - 50M",
          submittedAt: new Date(Date.now() - 6 * 60 * 60 * 1000),
          deadline: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000)
        },
        {
          id: "RFQ-2024-004",
          title: "Cybersecurity Assessment and Implementation",
          customerName: "Grace Namugga",
          company: "Makerere University",
          category: "Security",
          status: "pending",
          priority: "medium",
          budget: "UGX 30M - 75M",
          submittedAt: new Date(Date.now() - 8 * 60 * 60 * 1000),
          deadline: new Date(Date.now() + 21 * 24 * 60 * 60 * 1000)
        },
        {
          id: "RFQ-2024-005",
          title: "Cloud Migration Services for SME",
          customerName: "Peter Kiggundu",
          company: "TechStart Uganda Ltd",
          category: "Cloud Services",
          status: "rejected",
          priority: "low",
          budget: "UGX 10M - 25M",
          submittedAt: new Date(Date.now() - 12 * 60 * 60 * 1000),
          deadline: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000)
        }
      ],
      revenueData: [
        { month: 'Jan', revenue: 32000000, target: 35000000 },
        { month: 'Feb', revenue: 28000000, target: 35000000 },
        { month: 'Mar', revenue: 41000000, target: 35000000 },
        { month: 'Apr', revenue: 38000000, target: 40000000 },
        { month: 'May', revenue: 45000000, target: 40000000 },
        { month: 'Jun', revenue: 42000000, target: 40000000 },
        { month: 'Jul', revenue: 48000000, target: 45000000 },
        { month: 'Aug', revenue: 52000000, target: 45000000 },
        { month: 'Sep', revenue: 45200000, target: 45000000 }
      ],
      notifications: [
        {
          id: 1,
          type: 'rfq',
          title: 'New High-Priority RFQ Submitted',
          message: 'Ministry of ICT submitted RFQ for network infrastructure upgrade worth UGX 50M+',
          priority: 'high',
          timestamp: new Date(Date.now() - 15 * 60 * 1000),
          actionUrl: '/rfq-processing?rfq=RFQ-2024-001'
        },
        {
          id: 2,
          type: 'payment',
          title: 'Payment Confirmation Received',
          message: 'Uganda Commercial Bank completed payment for RFQ-2024-002 (UGX 45M)',
          priority: 'medium',
          timestamp: new Date(Date.now() - 45 * 60 * 1000),
          actionUrl: '/payment-reconciliation'
        },
        {
          id: 3,
          type: 'system',
          title: 'System Maintenance Scheduled',
          message: 'Scheduled maintenance window: Sunday 2:00 AM - 4:00 AM EAT',
          priority: 'low',
          timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
          actionUrl: '/admin-settings'
        },
        {
          id: 4,
          type: 'customer',
          title: 'New Customer Registration',
          message: 'TechStart Uganda Ltd completed registration and verification',
          priority: 'low',
          timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000),
          actionUrl: '/customer-management'
        },
        {
          id: 5,
          type: 'order',
          title: 'Order Fulfillment Update',
          message: 'Network equipment for Kampala City Council shipped and in transit',
          priority: 'medium',
          timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000),
          actionUrl: '/order-management'
        }
      ],
      customerEngagement: [
        { name: 'Active', value: 856 },
        { name: 'New', value: 234 },
        { name: 'Repeat', value: 445 },
        { name: 'At Risk', value: 123 },
        { name: 'Inactive', value: 67 }
      ]
    };

    // Simulate API loading
    setTimeout(() => {
      setDashboardData(mockData);
      setIsLoading(false);
    }, 1000);
  }, [dateRange]);

  const breadcrumbs = [
    { label: 'Home', path: '/', icon: 'Home' },
    { label: 'Admin Dashboard', path: '/admin-dashboard', icon: 'Shield', isLast: true }
  ];

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <MainNavigation user={currentUser} />
        <div className="pt-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex items-center justify-center h-64">
              <div className="flex items-center space-x-3">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                <span className="text-lg text-muted-foreground">Loading dashboard...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <MainNavigation user={currentUser} />
      <div className="pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <BreadcrumbNavigation customBreadcrumbs={breadcrumbs} />
          
          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-foreground mb-2">Admin Dashboard</h1>
              <p className="text-muted-foreground">
                Comprehensive business intelligence and management tools for TechTribes operations
              </p>
            </div>
            
            <div className="flex items-center space-x-4 mt-4 lg:mt-0">
              <div className="flex items-center space-x-2">
                <Icon name="Calendar" size={16} className="text-muted-foreground" />
                <select 
                  value={dateRange}
                  onChange={(e) => setDateRange(e?.target?.value)}
                  className="text-sm border border-border rounded-md px-3 py-1 bg-background text-foreground"
                >
                  <option value="7d">Last 7 days</option>
                  <option value="30d">Last 30 days</option>
                  <option value="90d">Last 90 days</option>
                  <option value="1y">Last year</option>
                </select>
              </div>
              
              <Button variant="outline" size="sm">
                <Icon name="Download" size={16} />
                Export Report
              </Button>
              
              <Button variant="default" size="sm">
                <Icon name="RefreshCw" size={16} />
                Refresh
              </Button>
            </div>
          </div>

          {/* KPI Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 mb-8">
            {dashboardData?.kpis?.map((kpi, index) => (
              <KPICard
                key={index}
                title={kpi?.title}
                value={kpi?.value}
                change={kpi?.change}
                changeType={kpi?.changeType}
                icon={kpi?.icon}
                trend={kpi?.trend}
              />
            ))}
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-8 mb-8">
            {/* Revenue Chart - Takes 2 columns */}
            <div className="xl:col-span-2">
              <RevenueChart 
                data={dashboardData?.revenueData}
                type="bar"
                title="Revenue vs Target Analysis"
              />
            </div>
            
            {/* Customer Engagement Chart */}
            <div className="xl:col-span-1">
              <CustomerEngagementChart data={dashboardData?.customerEngagement} />
            </div>
          </div>

          {/* Secondary Content Grid */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 mb-8">
            {/* Recent RFQs */}
            <div>
              <RecentRFQList rfqs={dashboardData?.recentRFQs} />
            </div>
            
            {/* Notifications Panel */}
            <div>
              <NotificationPanel notifications={dashboardData?.notifications} />
            </div>
          </div>

          {/* Quick Actions Panel */}
          <QuickActionPanel />

          {/* System Status Footer */}
          <div className="mt-8 pt-8 border-t border-border">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center space-x-4 mb-4 sm:mb-0">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-success rounded-full"></div>
                  <span className="text-sm text-muted-foreground">System Status: Operational</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Activity" size={14} className="text-success" />
                  <span className="text-sm text-muted-foreground">Uptime: 99.8%</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Users" size={14} className="text-primary" />
                  <span className="text-sm text-muted-foreground">Active Users: 45</span>
                </div>
              </div>
              
              <div className="text-sm text-muted-foreground">
                Last updated: {new Date()?.toLocaleString('en-UG', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  timeZone: 'Africa/Kampala'
                })} EAT
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;